export default __webpack_public_path__ + "static/media/banner.a2e0f7c3.png";